// const API_URL = "http://hacienda.harrys:8000/app";
const API_URL = "https://admin.haciendacafe.com/app";

const USER_COOKIE = 'hacienda-admin';


export {
    API_URL,
    USER_COOKIE,
}